

















































































































































import { UserStore } from '@/store/modules/user';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSformTable from '../../../components/AMSformTable.vue';
import AMSTable from '../../../components/AMSTable.vue';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSDialog from '../../../components/AMSDialog.vue';
import AMSProductCategorySelector from '@/components/AMSProductCategorySelector.vue';
import { allStaff } from '@/api/staff';
import utils from '@/utils/utils';
import { getModuleName } from '@/utils/utils';
import { emptyRule } from '@/utils/rules';
import { cancelMaterial, delMaterials } from '@/api/materials';
import { AppStore } from '@/store/modules/app';
import moment from 'moment';
interface Form {
  keyFilter?: string;
  receiverFilter?: string;
  productCategoryId?: string;
  beginTime?: String;
  endTime?: String;
  state?: string;
  applicantId?: string;
}

@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-dialog': AMSDialog,
    'ams-product-category-selector': AMSProductCategorySelector
  }
})
export default class Materials extends Vue {
  cancelOrDelRemark: String = ''; //删除或取消的备注
  valid: Boolean = false;
  breadcrumbsItems = [
    {
      text: '营销管理',
      disabled: false,
      href: 'materials'
    },
    {
      text: '物料申请',
      disabled: true
    }
  ];
  api: string = '/api/MaterialOrder/List';
  form: Form = { state: '' };
  initForm() {
    this.form = {};
    this.lastTime =''
    this.startTime =''
  }
  rules = {
    number: [],
    nameRules: [emptyRule('备注')]
  };
  statusList = [
    { value: '', text: '全部' },
    { value: 'Pending', text: '待审核' },
    // { value: 'PendingConfirm', text: '待确认' },
    { value: 'Order', text: '待发货' },
    { value: 'PartialDelivery', text: '部分发货' },
    { value: 'MaterialPendingGiveOut', text: '待发放' },
    { value: 'MaterialPartialGivenOut', text: '部分发放' },
    { value: 'MaterialReceiving', text: '待领取' },
    { value: 'Finished', text: '已完成' },
    { value: 'Canceled', text: '已关闭' }
  ];
  BeginTime = false;
  EndTime = false;
  date = new Date().toISOString().substr(0, 10);
  cancelOrDelDialog = false;
  deleteItemId: String = '';
  requestLoading: boolean = false;
  staffList: Array<object> = [];
  modaltitle: string = '';
  modelWarning: String = '';
  modalType: String = '';
  materialId: String = '';
  lastTime = '';
  startTime = '';
  headers = [
    {
      text: '申请编号',
      value: 'number',
      sortable: false,
      align: 'left',
      width: 160,
      status: 'status'
    },
    {
      text: '申请人',
      value: 'applicant',
      sortable: false,
      align: 'left',
      width: 140,
      status: 'status',
      render: (h: Function, param: any) => {
        return h('div', param.row[param.keyName].name);
      }
    },
    { text: '提交时间', value: 'creationTime', isFormatDate: true, sortable: false, width: 140, align: 'left', status: 'status' },
    {
      text: '客户类型',
      value: 'selectedCustomerType',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        return h('div', this.switchType(param.row[param.keyName]));
      },
      width: 100
    },
    {
      text: '客户信息',
      value: 'customerInfo',
      align: 'left',
      width: 180,
      status: 'status',
      render: (h: Function, param: any) => {
        return h('div', (param.row.customerName || '') + ' ' + (param.row.customerPhone || ''));
      }
    },
    {
      text: '状态',
      value: 'state',
      sortable: false,
      align: 'left', width:80,
      render: (h: Function, param: any) => {
        return h(
          'div',
          {
            style: {
              color: this.switchStatus(param.row[param.keyName])!.color
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          this.switchStatus(param.row[param.keyName])!.text
        );
      }
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      width: 180,
      sortable: false,
      isDetail: [
        {
          routerName: 'materials_view',
          text: '查看',
          color: '#1ABC9C',
          isParams: true,
        },
        {
          routerName: 'materials_edit',
          text: '修改',
          color: '#1ABC9C',
          query: { isEdit: true },
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('MarketingManager.MaterialApplication.CreateOrEdit');
            return permFlag && row.state === 'Pending';
          }
        },
        {
          routerName: 'materials_view',
          text: '审核',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('MarketingManager.MaterialApplication.Review');
            return permFlag && row.state === 'Pending';
          }
        },
        {
          routerName: 'materials_view',
          callBack: (btn: any, row: any, key: string) => {},
          text: '发货',
          color: '#1ABC9C',
          isParams: true,
          query: { tabActive: 'materialsShip' },
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('OrderManager.ShipmentList.ShipAndCancelShip');
            return permFlag && (row.state === 'Order' || row.state === 'PartialDelivery');
          }
        },
        {
          text: '领取',
          routerName: 'materials_view',
          color: '#1ABC9C',
          isParams: true,
          query: { tabActive: 'materialsShip' },
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('MarketingManager.MaterialApplication.Receive');
            return permFlag && (row.state === 'MaterialPartialGivenOut' || row.state === 'MaterialReceiving');
          }
        },
        {
          routerName: 'materials_view',
          text: '发放',
          color: '#1ABC9C',
          isParams: true,
          query: { tabActive: 'materialsShip' },
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('OrderManager.ShipmentList.ShipAndCancelShip');
            return permFlag && (row.state === 'MaterialPendingGiveOut' || row.state === 'MaterialPartialGivenOut');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.materialId = row.item.id;
            this.cancelApplication(btn, row, key, 'cancel');
          },
          text: '取消',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('MarketingManager.MaterialApplication.Cancel');
            return permFlag && row.state !== 'Canceled' && row.state !== 'Finished' && row.state !== 'MaterialReceiving';
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.materialId = row.item.id;
            this.cancelApplication(btn, row, key, 'del');
          },
          text: '删除',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('MarketingManager.MaterialApplication.Delete');
            return permFlag && row.state === 'Canceled';
          }
        }
      ]
    }
  ];
  created() {
    this.getStaff();
    this.initForm();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
      this.startTime = this.form.beginTime?moment(this.form.beginTime as string).format('YYYY-MM-DD'):'';
      this.lastTime = this.form.endTime?moment(this.form.endTime as string).format('YYYY-MM-DD'):'';
    }
  }
  // 打开删除或取消的modal
  cancelApplication(btn: any, row: any, key: string, type?: string) {
    this.materialId = row.item.id;
    this.cancelOrDelDialog = true;
    this.modalType = type || '';
    this.cancelOrDelRemark = '';
    if (type === 'del') {
      this.modaltitle = '删除申请单';
      this.modelWarning = '确定删除该申请单吗？';
    } else {
      // (this.$refs.cancelDelForm as any).resetValidation();
      this.modaltitle = '取消申请单';
      if (row.item.state === 'PartialDelivery') {
        //部分发货
        this.modelWarning = '商品已部分发货，确定取消未发货的商品？ 取消后，已出库的商品将取消出库并释放库存';
      } else if (row.item.state === 'MaterialPartialGivenOut') {
        //部分发放
        this.modelWarning = '商品已部分领取，确定取消未领取的商品？ 取消后，已出库的商品将取消出库并释放库存';
      } else {
        this.modelWarning = '确定取消申请单吗？';
      }
    }
  }

  // 删除或取消
  cancelOrDelSure() {
    if (this.modalType === 'del') {
      this.cancelOrDelDialog = false;

      delMaterials(this.materialId)
        .then((data: any) => {
          (this.$refs['formtable'] as HTMLFormElement).query();
          this.materialId = '';
          AppStore.ShowSuccess('删除成功！');
        })
        .finally(() => {
          this.requestLoading = false;
        });
    } else if (this.modalType === 'cancel') {
      if ((this.$refs.cancelDelForm as HTMLFormElement).validate()) {
        this.cancelOrDelDialog = false;
        cancelMaterial({
          orderId: this.materialId,
          remark: this.cancelOrDelRemark
        }).then(() => {
          this.cancelOrDelDialog = false;
          this.materialId = '';
          (this.$refs['formtable'] as HTMLFormElement).query();
        });
      }
    }

    // this.requestLoading = true;
  }

  // 取消删除或者取消取消申请
  cancelOrDelCancel() {
    this.cancelOrDelDialog = false;
    this.deleteItemId = '';
    this.requestLoading = false;
  }
  @Watch('lastTime', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.endTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('startTime', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.beginTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('BeginTime', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.BeginTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  @Watch('EndTime', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.EndTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  onEnter() {
    this.$refs.BeginTimeText && (this.$refs.BeginTimeText as any).blur();
    this.$refs.EndTimeText && (this.$refs.EndTimeText as any).blur();
  }

  get minDate() {
    return this.startTime;
  }

  getPermission(name: string) {
    return Utils.isPermission(name);
  }

  switchType(type: string) {
    switch (type) {
      case 'NewCustomer':
        return '新客户';
      case 'OldCustomer':
        return '老客户';
      case 'None':
        return '无';
    }
  }

  switchStatus(status: string) {
    switch (status) {
      case 'Pending': /// 待审核
        return { color: '#FE5500', text: '待审核' };
      case 'PendingConfirm':
        return { color: '#FE5500', text: '待确认' };
      case 'Order':
        return { color: '#FE5500', text: '待发货' };
      case 'PartialDelivery':
        return { color: '#FE5500', text: '部分发货' };
      case 'MaterialPendingGiveOut':
        return { color: '#FE5500', text: '待发放' };
      case 'MaterialPartialGivenOut':
        return { color: '#FE5500', text: '部分发放' };
      case 'MaterialReceiving':
        return { color: '#FE5500', text: '待领取' };
      case 'Finished':
        return { color: '#1abc9c', text: '已完成' };
      case 'Canceled':
        return { color: '#999999', text: '已关闭' };
    }
  }

  addMaterials() {
    this.$router.push({
      name: 'materials_create'
    });
  }

  getStaff() {
    allStaff({ isActive: true }).then((data: any) => {
      this.staffList = [{ value: '', text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }

  onOperatorIdClear() {
    setTimeout(() => {
      this.form.applicantId = '';
    }, 1);
  }

  onStatusClear() {
    setTimeout(() => {
      this.form.state = '';
    }, 1);
  }
}
